<template>
    <div class="hint">
        <div class="panel">
            <div class="panel-body">
                <template>
                    <h3 class="mar-bot-none"><slot name="title"></slot></h3>
                    <div class="hint__content">
                        <slot></slot>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
};
</script>
<style scoped>
.hint {
    min-width: 18.5rem;
    max-width: 25rem;
}
.panel-body {
    padding: var(--spacer3) var(--spacer-layout1) var(--spacer-layout1);
}

.hint__content  {
    font-size: var(--font-size-smaller);
}
</style>
